import { Component, Input } from '@angular/core';
import { FormBuilder, FormArray } from '@angular/forms';

import { Filter, FilterService } from '../../filters/shared';
import { ProductFormService } from '../shared'

@Component({
  selector: 'product-filter-form',
  templateUrl: './product-filter-form.component.html',
  styleUrls: ['./product-filter-form.component.scss']
})
export class ProductFilterFormComponent {
  @Input() category: string;
  @Input('array') formArray: FormArray; 

  filters: Array<Filter> = [];
  isInited: boolean = false;
  prevCategory: string;
  checkedMap: Array<boolean> = [];

  constructor(
    private fb: FormBuilder,
    private filterService: FilterService,
    private productFormService: ProductFormService
  ) {}

  ngOnInit() {
    this.isInited = true;
  }

  ngOnChanges() {
    if (this.isInited) {
      if (this.category != this.prevCategory) {      
        while(this.formArray.length) {
          this.formArray.removeAt(0);
        }
          
        this.prevCategory = this.category;
      }
    } else {
      this.prevCategory = this.category;
    }

    if (this.category) {
      this.filterService
        .getByCategory(this.category)
        .subscribe(filters => {
          this.filters = filters;
          this.initCheckMap();
        })
      ;
    } else {
      this.filters = [];
    }
  }
  
  toggleFilterValue(filter: string, value: string) {
    let controlIndex = this.getControlIndex(filter, value);

    if (controlIndex !== null) {
      this.formArray.removeAt(controlIndex);
    } else {
      let form = this.productFormService.getFilterForm();
      form.removeControl('_id');
      form.get('filter').patchValue(filter);
      form.get('value').patchValue(value);
      this.formArray.push(form);
    }

    setTimeout(() => {
      this.checkedMap[`${filter}-${value}`] = (controlIndex !== null) ? false : true;
    }, 100);
  }

  private initCheckMap() {
    this.checkedMap = [];

    this.filters.forEach(filter => {
      filter.values.forEach(value => {
        this.checkedMap[`${filter._id}-${value._id}`] = this.filterValueExists(filter._id, value._id);
      });
    });
  }

  private filterValueExists(filter: string, value: string): boolean {
    return (this.getControlIndex(filter, value) === null) ? false : true;
  }

  private getControlIndex(filter: string, value: string) {
    let controlIndex = null;

    this.formArray.controls.forEach((control, index) => {
      if (
        (control.get('filter').value == filter) &&
        (control.get('value').value == value)
      ){
        controlIndex = index;
      }
    });

    return controlIndex;
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-filter-form/product-filter-form.component.ts